"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var Observable_1 = require("rxjs/Observable");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/takeUntil");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var quick_filter_dto_1 = require("../../../service/quick-filter-dto");
var noop_1 = require("rxjs/util/noop");
var QuickFilterComponent = /** @class */ (function () {
    function QuickFilterComponent(kbService, classifierService, currentLanguageProvider, stateService, authorizationService, authService, languageService) {
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.stateService = stateService;
        this.authorizationService = authorizationService;
        this.authService = authService;
        this.languageService = languageService;
        this.isLoadedSubject = new ReplaySubject_1.ReplaySubject();
        /**
             * Event to listen to get created filter.
             * @type {EventEmitter<object>}
             * @default
             */
        this.getQuickFilter = new core_1.EventEmitter();
        /**
             * Is used to init view after all needed info is loaded.
             * @type {boolean}
             * @private
             */
        this._isReady = false;
        this.ngUnsubscribe = new Subject_1.Subject();
        this._selectedIndex = -1;
        this.chipMaxWidth = 220;
        this.maxPercentOfPortfolioToolbarSection = 80;
        this.searchInputWidth = 120;
        this.thresholdOfComboBoxView = 650;
        this._isComboBoxView = false;
    }
    QuickFilterComponent.prototype.isLoaded = function () {
        return this.isLoadedSubject.asObservable();
    };
    Object.defineProperty(QuickFilterComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickFilterComponent.prototype, "isComboBoxView", {
        get: function () {
            return this._isComboBoxView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickFilterComponent.prototype, "filterItems", {
        get: function () {
            return this._filterItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickFilterComponent.prototype, "selectedIndex", {
        get: function () {
            return this._selectedIndex;
        },
        set: function (value) {
            this._selectedIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickFilterComponent.prototype, "quickFilterDropDownStartIndex", {
        get: function () {
            return this._quickFilterDropDownStartIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickFilterComponent.prototype, "portfolioLanguageId", {
        get: function () {
            return this._portfolioLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    QuickFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._isReady = false;
        this.reRenderQuickFilters(); // for initial quickFilter state
        var metaFields$ = this.kbService.getMetaFields(this.categorySystemName);
        var inputLanguages$ = this.languageService.getInputLanguages();
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var defaultLanguage$ = this.languageService.getDefaultLanguage();
        Observable_1.Observable.combineLatest(currentLanguage$, inputLanguages$, defaultLanguage$, metaFields$)
            .switchMap(function (data) {
            var currentLanguage = data[0], inputLanguages = data[1], defaultLanguage = data[2], metaFields = data[3];
            var currentLanguageId = currentLanguage.getId();
            if (inputLanguages.some(function (inputLanguage) { return inputLanguage.getId() === currentLanguageId; })) {
                _this._portfolioLanguageId = currentLanguageId;
            }
            else {
                _this._portfolioLanguageId = defaultLanguage.getId();
            }
            var metaField = metaFields.find(function (field) {
                return field.getSystemName() === _this.filterSystemName;
            });
            if (metaField === undefined) {
                throw Error("Cannot find field with " + _this.filterSystemName + " systemName!");
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
                return _this.classifierService.loadClassifiersView(metaField.getCompoundCategorySystemName())
                    .map(function (loadedClassifiers) {
                    if (_this.filterItemIdsToShow && _this.filterItemIdsToShow.length > 0) {
                        loadedClassifiers = loadedClassifiers.filter(function (value) { return _this.filterItemIdsToShow.indexOf(value.id) >= 0; });
                    }
                    _this._filterItems = loadedClassifiers;
                    _this.initialFilterItems = _this._filterItems.slice();
                    setTimeout(function () {
                        _this.calculateQuickFilterDropDownStartIndex();
                        _this._isReady = true;
                        _this.isLoadedSubject.next(true);
                    }, 1300);
                });
            }
            else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE) {
                var metCategory$ = _this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(_this.categorySystemName));
                var userData$ = _this.authService.getUserData();
                return Observable_1.Observable.combineLatest(metCategory$, userData$)
                    .switchMap(function (data) {
                    var metaCategory = data[0], userData = data[1];
                    var requestDataDto = {
                        categorySystemNames: [_this.categorySystemName],
                        conditionalPermissionValues: null,
                        permissionType: idm_authorization_client_js_1.PermissionType.VIEW,
                        userId: userData.userId,
                        workflowStateId: null,
                    };
                    var states$ = _this.stateService.getStates(metaCategory.getWFProcessId());
                    var workflowStateMetaField$ = _this.kbService.getWorkflowStateMetaField(_this.categorySystemName);
                    var categoryPermissionsValues$ = _this.authorizationService.getCategoryPermissionsValues(requestDataDto);
                    return Observable_1.Observable.zip(states$, workflowStateMetaField$, categoryPermissionsValues$)
                        .map(function (data) {
                        var states = data[0], metaField = data[1], categoryPermissionsMap = data[2];
                        if (_this.filterItemIdsToShow && _this.filterItemIdsToShow.length > 0) {
                            states = states.filter(function (state) { return _this.filterItemIdsToShow.indexOf(state.getId()) >= 0; });
                        }
                        var wfMetaFieldSystemName = metaField.getMetaFieldId().getSystemName();
                        var customStateIds = new Array();
                        var permissionValueDtos = Array.from(categoryPermissionsMap.get(_this.categorySystemName));
                        var full = false;
                        for (var i = 0; !full && i < permissionValueDtos.length; ++i) {
                            switch (permissionValueDtos[i].access) {
                                case idm_authorization_client_js_1.Access.DENIED: {
                                    break;
                                }
                                case idm_authorization_client_js_1.Access.FULL: {
                                    full = true;
                                    break;
                                }
                                case idm_authorization_client_js_1.Access.CUSTOM: {
                                    if (permissionValueDtos[i].customAccess === idm_authorization_client_js_1.CustomAccess.WORKFLOW ||
                                        permissionValueDtos[i].customAccess === idm_authorization_client_js_1.CustomAccess.WORKFLOWFIELD) {
                                        permissionValueDtos[i].customValues.expressions.forEach(function (expression) {
                                            var expressionObj = JSON.parse(expression.toString());
                                            var wfStateIds;
                                            if (expressionObj[wfMetaFieldSystemName]) {
                                                //case when role has full access to category
                                                wfStateIds = expressionObj[wfMetaFieldSystemName]['$in'];
                                            }
                                            else {
                                                //case when role has workflow or workflowfield permission
                                                //authorization service will append workflow ids into $and block, near of expression
                                                wfStateIds = expressionObj["$and"][1][wfMetaFieldSystemName]["$in"];
                                            }
                                            customStateIds = customStateIds.concat(wfStateIds);
                                        });
                                    }
                                    else {
                                        full = true;
                                    }
                                    break;
                                }
                            }
                        }
                        _this._filterItems = full ? states : states.filter(function (state) { return customStateIds.indexOf(state.getId()) >= 0; });
                        _this.initialFilterItems = full ? states.slice() : states.filter(function (state) { return customStateIds.indexOf(state.getId()) >= 0; }).slice();
                        setTimeout(function () {
                            _this.calculateQuickFilterDropDownStartIndex();
                            _this._isReady = true;
                            _this.isLoadedSubject.next(true);
                        }, 1300);
                    });
                });
            }
            else {
                _this.isLoadedSubject.next(true);
                throw Error(_this.filterSystemName + " systemName is not lookup field for " + _this.categorySystemName + " entity!");
            }
        })
            .takeUntil(this.ngUnsubscribe)
            .subscribe(noop_1.noop, console.error);
    };
    QuickFilterComponent.prototype.reRenderQuickFilters = function (event) {
        var innerWidth = event ? event.target.innerWidth : window.innerWidth;
        if (innerWidth < this.thresholdOfComboBoxView) {
            this._isComboBoxView = true;
        }
        else {
            this._isComboBoxView = false;
            this.calculateQuickFilterDropDownStartIndex();
        }
    };
    //Calculation how much chips fits in the section
    //Calculation how much chips fits in the section
    QuickFilterComponent.prototype.calculateQuickFilterDropDownStartIndex = 
    //Calculation how much chips fits in the section
    function () {
        if (this.chipContainer) {
            var parentWidth = 800; //default parentWidth, in case when portfolio in the second tab.
            //get width of portfolio toolbar and calculate width of portfolio toolbar section (70%-120 of toolbar)
            if (this.chipContainer._elementRef.nativeElement.parentNode.parentNode.parentNode.parentNode.offsetWidth) {
                parentWidth = this.chipContainer._elementRef.nativeElement.parentNode.parentNode.parentNode.parentNode.offsetWidth *
                    this.maxPercentOfPortfolioToolbarSection / 100 - this.searchInputWidth;
            }
            //get number from which dropdown started
            var indexNumber = parentWidth / this.chipMaxWidth;
            //round and calculate index
            this._quickFilterDropDownStartIndex = Math.floor(indexNumber) - 1;
            if (this._selectedIndex > this._quickFilterDropDownStartIndex) {
                this.swapQuickFilterChip(this._selectedIndex);
            }
        }
    };
    QuickFilterComponent.prototype.onFilterChange = function (selectedId) {
        this.getQuickFilter.emit(new quick_filter_dto_1.QuickFilterDto(this.filterSystemName, selectedId));
    };
    QuickFilterComponent.prototype.buildFilterCriteria = function (quickFilterDto) {
        var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        var selectedId = quickFilterDto.selectedId;
        if (selectedId && selectedId !== -1) {
            this.selectedComboBoxItem(selectedId);
            filterBuilder.is(quickFilterDto.filterSystemName, selectedId);
            return filterBuilder.build();
        }
        else {
            this.selectedIndex = -1;
            return null;
        }
    };
    QuickFilterComponent.prototype.getItemName = function (item) {
        if (item instanceof idm_workflow_service_client_js_1.StateDto) {
            return item.getName().getValue(this.portfolioLanguageId);
        }
        else {
            return item.getName();
        }
    };
    QuickFilterComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    QuickFilterComponent.prototype.trackByFilterItems = function (index, item) {
        //both ClassifierView and StateDto have id field.
        return item.getId();
    };
    //Calculate width of dropdown chip menu
    //Calculate width of dropdown chip menu
    QuickFilterComponent.prototype.setDropDownMenuStyles = 
    //Calculate width of dropdown chip menu
    function (event) {
        var elem = document.getElementsByClassName('mat-menu-panel');
        var elem1 = document.getElementsByClassName("quick-filter__drop-down-chip-container");
        elem[0].style.minWidth = elem1[0].offsetWidth + 'px';
        event.stopPropagation();
    };
    QuickFilterComponent.prototype.selectChip = function (item, index) {
        this.onFilterChange(item.getId());
        this.swapQuickFilterChip(index);
    };
    QuickFilterComponent.prototype.selectedComboBoxItem = function (selectedId) {
        for (var i = 0; i < this._filterItems.length; ++i) {
            if (this._filterItems[i].getId() == selectedId) {
                this._selectedIndex = i;
                break;
            }
        }
    };
    QuickFilterComponent.prototype.swapQuickFilterChip = function (index) {
        if (index >= this.quickFilterDropDownStartIndex) {
            var tmp = this._filterItems[this._quickFilterDropDownStartIndex];
            this._filterItems[this._quickFilterDropDownStartIndex] = this._filterItems[index];
            this._filterItems[index] = tmp;
            this._selectedIndex = this._quickFilterDropDownStartIndex;
        }
        else {
            this._filterItems = this.initialFilterItems.slice();
            this._selectedIndex = index;
        }
    };
    QuickFilterComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-portfolio-quick-filter',
                    styles: [require('./quickfilter.component.css')],
                    template: require('./quickfilter.component.html'),
                },] },
    ];
    /** @nocollapse */
    QuickFilterComponent.ctorParameters = function () { return [
        { type: idm_kb_service_client_js_1.KbService, },
        { type: idm_classifier_service_client_js_1.ClassifierService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
        { type: idm_workflow_service_client_js_1.StateService, },
        { type: idm_authorization_client_js_1.AuthorizationService, },
        { type: idm_authentication_client_js_1.AuthenticationService, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
    ]; };
    QuickFilterComponent.propDecorators = {
        "categorySystemName": [{ type: core_1.Input },],
        "filterSystemName": [{ type: core_1.Input },],
        "filterItemIdsToShow": [{ type: core_1.Input },],
        "getQuickFilter": [{ type: core_1.Output },],
        "chipContainer": [{ type: core_1.ViewChild, args: ['chipContainer',] },],
    };
    QuickFilterComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                      <sis-portfolio-quick-filter\n                        [categorySystemName]=\"'%{categorySystemName}'\"\n                        [filterSystemName]=\"'%{filterSystemName}'\"\n                        [filterKey]=\"'%{filterKey}'\"\n                        [enableWorkflowBulkActions]=\"'%{enableWorkflowBulkActions}'\"\n                        [workflowBulkActionIds]=\"'%{workflowBulkActionIds}'\">\n                      </sis-portfolio-quick-filter>\n                   ",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_workflow_service_client_js_1.StateService,
            idm_authorization_client_js_1.AuthorizationService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_message_language_service_client_js_1.LanguageService])
    ], QuickFilterComponent);
    return QuickFilterComponent;
}());
exports.QuickFilterComponent = QuickFilterComponent;
//# sourceMappingURL=quickfilter.component.js.map